const API_URL = 'https://campin-project.herokuapp.com/';

export default API_URL;
